"use client";

// Italian header language switch + "EN" marker (IT-1). The switch is the
// shared language picker (components/languagePicker), which lists every
// language the current page exists in.
import { LanguagePicker } from "../languagePicker/languagePicker.comp";

export const LangSwitchIt = ({ className = "" }: { className?: string }) => (
  <LanguagePicker className={className} />
);

// Small "EN" marker for links that lead to a page only available in English.
export const EnTag = () => (
  <span
    lang="en"
    title="Pagina in inglese"
    style={{
      fontSize: "0.7em",
      border: "1px solid currentColor",
      borderRadius: 3,
      padding: "0 3px",
      marginLeft: 4,
      opacity: 0.7,
      verticalAlign: "middle",
      fontWeight: 500,
    }}
  >
    EN
  </span>
);
